import { useState, useRef } from "react";
import {
    LeftIcon, RightIcon
} from '../Files/svg_icons/index.js';



function WorkEthicsAndJourney (allProps) {

    const {myJourney, section_headings, work_ethics} = allProps;

    const startX = useRef(0);
    const startY = useRef(0);
    const dragging = useRef(false);

    const [ethicActive, setEthicActive] = useState(true)

    const onEthicJourneyClick = (val) => {
        setEthicActive(val);
    }

    const handleWeDragStart = (e) => {
        const touch = e.touches[0];
        startX.current = touch.clientX;
        startY.current = touch.clientY;
        dragging.current = false;
    } 

    const handleWeDragMove = (e, ethicTrueJourneyFalse) => {
        const touch = e.touches[0];
        const dx = touch.clientX - startX.current;
        const dy = touch.clientY - startY.current;

        if (!dragging.current) {
            if (Math.abs(dx) > Math.abs(dy)) {
                // It's a horizontal drag — trigger your event

                dragging.current = true;
                // Prevent vertical scroll
                // onHorizontalDrag(dx);

                if(dx < 0 && (ethicTrueJourneyFalse === false)) {
                    // e.preventDefault();
                    onEthicJourneyClick(ethicTrueJourneyFalse);
                } else if (dx > 0 && (ethicTrueJourneyFalse === true)) {
                    onEthicJourneyClick(ethicTrueJourneyFalse);
                }

            } else {
                // Let it scroll normally
                dragging.current = true;
            }
        }
    }

    return (
        <>

        

        <section className="tech-journey-section" id="tech-journey-section">
            <div 
                
                className={ethicActive === true ? "ethic-journey-container ethics-active" : "ethic-journey-container journey-active"}
            >
                <WorkEthichs myJourney={myJourney} section_headings={section_headings} work_ethics={work_ethics}
                    handleWeDragStart={handleWeDragStart} handleWeDragMove={handleWeDragMove} />
                

                <ShortJourney myJourney={myJourney} section_headings={section_headings} work_ethics={work_ethics}
                    handleWeDragStart={handleWeDragStart} handleWeDragMove={handleWeDragMove} />

                <div className="view-more">

                    <button onClick={() => onEthicJourneyClick(true) } disabled={ethicActive} > 
                        <img src={LeftIcon} className="left-right-svgs" alt="left icon" /> 
                        
                    </button>
                    <span
                        className="switch-tech-view"
                        
                    >
                        {ethicActive === true ? "1" : "2"}
                    </span>

                    <button onClick={() => onEthicJourneyClick(false) } disabled={!ethicActive}> 
                        <img src={RightIcon} className="left-right-svgs" alt="right icon" /> 
                    </button>
                </div>

            </div>
        </section>
        </>
    )
}

function WorkEthichs (props) {

    const {section_headings, work_ethics} = props;

    const {I_develop_arr, I_care_about_arr} = work_ethics;
    const {I_develop, I_care_about} = section_headings;
    return (
        <>
            <div className="work-ethics"
                onTouchStart={(eve) => props.handleWeDragStart(eve)}  
                onTouchMove={(eve) => props.handleWeDragMove(eve, false)}
            >
                <ul>
                    <h3>{I_develop}</h3>
                    {
                        I_develop_arr.map((iDev, idx) => (
                            <li key={idx}>{iDev}</li>
                        ))
                    }
                </ul>
                <ul>
                    <h3>{I_care_about}</h3>
                    {
                        I_care_about_arr.map((iCare, idx) => (
                            <li key={idx}>{iCare}</li>
                        ))
                    }
                </ul>

            </div>
        </>
    )
}

function ShortJourney(props) {

    const myJourney = props.myJourney;
    const section_headings = props.section_headings;

    const {short_summary} = myJourney;

    return (
        <>
            <div className="my-journey" 
                onTouchStart={(eve) => props.handleWeDragStart(eve)}  
                onTouchMove={(eve) => props.handleWeDragMove(eve, true)}
            >
                <h2>{section_headings.journey}</h2>
                <p className="career-journey-paragraph">
                    {
                        short_summary.map((journeyPoints, jIdx) => (
                            <span key={jIdx}>
                                {`${journeyPoints} `}
                            </span>
                        ))
                    }
                </p>
            </div>

        </>
    );
}







export default WorkEthicsAndJourney;


